/** A shareable Google Trends "explore" link so the user can verify demand. */
export function trendsUrl(term: string, geo = 'US'): string {
  return `https://trends.google.com/trends/explore?q=${encodeURIComponent(
    term,
  )}&geo=${geo}`;
}

/** Compact search-volume label, e.g. 1200 -> "1.2k". */
export function formatVolume(n: number | null | undefined): string {
  if (n == null) return '';
  if (n >= 1000) return `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k`;
  return String(n);
}
